import React, { useRef } from 'react';
import { json, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { requestGetInvoiceDetail } from "../../Redux/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

function InvoicePrint(props) {
    const printRef = useRef();
    const { id } = useParams();
    const [logindetails, setlogindetails] = useState({});
    const [invoiceData, setSaleInvoiceDetail] = useState({});

    useEffect(() => {
        const data1 = JSON.parse(localStorage.getItem("user"));
        if (data1 && data1.data?.userToken) {
            props.requestGetInvoiceDetail(
                {
                    data: {
                        param1: '611337539322',
                        param2: id,
                        token: data1.data.userToken
                    },
                }
            );
        }
    }, [id]);

    useEffect(() => {
        const invoiceDetails = props.data.getInvoiceDetailData.data.data;
        if (invoiceDetails) {
            setSaleInvoiceDetail(invoiceDetails);
        }
    }, [props.data.getInvoiceDetailData]);

    const handlePrint = () => {
        const printContents = printRef.current.innerHTML;
        const win = window.open('', '', 'height=600,width=800');
        win.document.write('<html><head><title>Invoice</title>');
        win.document.write('<style>body{ font-family: Arial; } table{ width: 100%; border-collapse: collapse; } th, td{ border: 1px solid #ccc; padding: 8px; }</style>');
        win.document.write('</head><body>');
        win.document.write(printContents);
        win.document.write('</body></html>');
        win.document.close();
        win.print();
    };


    return (
        <div>
            <button onClick={handlePrint}>🖨️ Print Invoice</button>
            <div ref={printRef} style={{ maxWidth: '800px', margin: 'auto', padding: '30px', border: '1px solid #eee', fontFamily: 'Segoe UI, sans-serif', fontSize: '14px', lineHeight: '1.5', color: '#333', background: '#fff' }}>
                <div style={{ borderBottom: '2px solid #333', paddingBottom: '10px', marginBottom: '20px' }}>
                    <h1 style={{ margin: 0 }}>🧾 INVOICE</h1>
                    <p style={{ margin: 0, color: '#777' }}>Invoice No: <strong>{invoiceData.invoiceNo}</strong></p>
                    <p style={{ margin: 0, color: '#777' }}>Date: <strong>{invoiceData.dateWithTime}</strong></p>
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <h3 style={{ marginBottom: '5px' }}>Billed To:</h3>
                    <p style={{ margin: 0 }}><strong>{invoiceData.clientDetails?.clientName || '-'}</strong></p>
                    <p style={{ margin: 0 }}>{invoiceData.clientDetails?.roomNo}, {invoiceData.clientDetails?.address}</p>
                    <p style={{ margin: 0 }}>📞 {invoiceData.clientDetails?.phoneNo}</p>
                </div>

                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                    <thead style={{ background: '#f5f5f5' }}>
                        <tr>
                            <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Item</th>
                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Qty</th>
                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Price</th>
                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoiceData.saleDetails?.map((item, idx) => (
                            <tr key={idx} style={{ background: idx % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                <td style={{ padding: '8px', border: '1px solid #eee' }}>{item.particulars}</td>
                                <td style={{ padding: '8px', border: '1px solid #eee', textAlign: 'center' }}>{item.quantity}</td>
                                <td style={{ padding: '8px', border: '1px solid #eee', textAlign: 'right' }}>₹{item.rate.toFixed(2)}</td>
                                <td style={{ padding: '8px', border: '1px solid #eee', textAlign: 'right' }}>₹{item.amount.toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div style={{ textAlign: 'right' }}>
                    <p style={{ fontSize: '16px', margin: 0 }}>
                        <strong>Grand Total:</strong> ₹
                        {invoiceData.saleDetails
                            ? invoiceData.saleDetails.reduce((sum, item) => sum + item.amount, 0).toFixed(2)
                            : '0.00'}
                    </p>
                </div>

                <div style={{ marginTop: '40px', textAlign: 'center', fontStyle: 'italic', color: '#999' }}>
                    Thank you for your business!
                </div>
            </div>
        </div>
    );
};
const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestGetInvoiceDetail }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InvoicePrint);
